import { Page } from '@/components/layout/page/page.tsx'
import { DisplaySettings } from '@/modules/display-settings/ui/display-settings.tsx'

export const DisplaySettingsView = () => {
  return (
    <Page title="Display Settings">
      <hr />
      <DisplaySettings />
    </Page>
  )
}
